export default "__VITE_ASSET__e921a2e2__"